export function findCommonStrings(listOfArrays: Array<string[]>) {
  return listOfArrays.length > 0
    ? listOfArrays[0].filter((str) =>
        listOfArrays.every((stringArray) => stringArray.includes(str)),
      )
    : []
}
